// for 500 status
export const COMMON_ERROR = 'Looks like something went wrong on our end. Please try again later.'
export const DEFAULT_SERVER_ERROR = 'Something went wrong. Please try again later.'

export const mapMsgByStatus = {
  500: COMMON_ERROR,
}

export const extractErrorMessage = (error) => {
  if (!error.response || error.status === 500 || !Object.keys(error.response).length)
    return COMMON_ERROR
  else if (error.response.message) return error.response.message
  else if (error.response.error_message) {
    if (typeof error.response.error_message === 'string') {
      return error.response.error_message
    } else return extractSerializerFieldsErrors(error.response.error_message)
  } else {
    return extractSerializerFieldsErrors(error.response)
  }
}

// https://stackoverflow.com/questions/30469261/checking-for-typeof-error-in-js
export const isError = (obj) => Object.prototype.toString.call(obj) === '[object Error]'

function extractSerializerFieldsErrors(obj) {
  return Object.keys(obj)
    .map((elem) => `${elem}: ${Array.isArray(obj[elem]) ? obj[elem][0] : obj[elem]}`)
    .join('; ')
}
